import { useSyncExternalStore } from 'react';
import { cardsVersion, subscribeCards } from '../utils/actionCardStore';

/** Re-render on any card's flip or local change (utils/actionCardStore). */
export function useActionCardStore(): number {
  return useSyncExternalStore(subscribeCards, cardsVersion, cardsVersion);
}
